export default "__VITE_ASSET__6cb50c0c__"